export enum CostStructurePartName {
  Account = 'Account',
  Department = 'Dept'
}
